import { DataContainerService } from "../../../../infrastructure/datacontainer.service";
import { TransportData } from "../../../../infrastructure/transportdata";
import { DashboardsFetchRequest } from "./dashboardfetchrequest";

// =========================================================
// Nested response shapes
// =========================================================
export interface DashboardKeyFigures {
    total_population_covered_by_asha: number;
    total_population_covered_by_asha_percentage: number;
    total_population_assigned_to_asha: number;
    no_of_families: number;
    no_of_families_percentage: number;
    no_of_children_from_zero_to_six_years: number;
    no_of_children_from_zero_to_six_years_percentage: number;
    no_of_members_above_thirty_years: number;
    no_of_members_above_thirty_years_percentage: number;
    no_of_members_above_sixty_five_years: number;
    no_of_members_above_sixty_five_years_percentage: number;
}

export interface DashboardOverview {
    // Family Register
    pending_families: number;
    approved_families: number;
    native_families: number;
    migrated_families: number;

    // Eligible Couple Register
    total_eligible_couple: number;
    couple_protection_rate_percentage: number;
    sterilized_couple: number;
    male_sterilization: number;
    female_sterilization: number;
    infertile_couple: number;
    family_planning_used: number;

    // ANC Register
    total_anc: number;
    fully_protected: number;
    expected_deliveries: number;
    high_risk_maata: number;
    normal_maata: number;
    pregnancy_registered: number;
    severe_anemia: number;

    // Birth Register
    total_birth: number;
    total_male_birth: number;
    total_female_birth: number;

    // HBNC Register
    total_hbnc: number;
    total_hbnc_registered: number;
    total_hbnc_visits_completed: number;
    zero_visits_completed: number;
    defective_children: number;
    child_death: number;
    nicu: number;
    nbsu: number;
    sncu: number;

    // Child Immunization Register
    total_child_immunized: number;
    fully_immunized_children: number;
    children_with_no_vaccination: number;
    children_with_incomplete_immunization: number;

    // Death Register
    total_death: number;
    anc_death: number;
    still_birth: number;
    zero_to_five_years_death: number;
    thirty_above_death: number;
    sixtyfive_above_death: number;

    // PNC Register
    total_pnc: number;
    total_pnc_visits_completed: number;
    high_risk_pnc: number;
    zero_visit_completed_pnc: number;
    normal_pnc: number;

    // Pregnancy Loss Register
    total_pregnancy_loss: number;
    abortion: number;
    miscarriage: number;
}

export class Dashboards {
    public static readonly EmbedCollectionName: string = "dashboard";

    FetchRequest: DashboardsFetchRequest = null as any;
    Rows: any[] = [];
    Columns: any[] = [];
    FromDate: string = '';
    ToDate: string = '';
    ChapterRef: number = 0;

    // Server formatted date
    public as_on_date: string = '';
    public as_on_date_formatted: string = '';

    // =========================================================
    // New nested response shape
    // =========================================================
    public key_figures: DashboardKeyFigures = {} as DashboardKeyFigures;
    public overview: DashboardOverview = {} as DashboardOverview;

    // =========================================================
    // Legacy / Backward Compatibility properties (Old Dashboard)
    // =========================================================
    public register_maata: number = 0;
    public register_maata_due: number = 0;
    public high_risk_register_maata: number = 0;
    public normal_register_maata: number = 0;
    public no_of_pnc: number = 0;
    public pnc_referred_mother: number = 0;
    public pnc_completed_mother: number = 0;
    public no_of_hbnc: number = 0;
    public govt_hospital_birth_hbnc: number = 0;
    public pre_mature_baby_hbnc: number = 0;
    public disable_baby_hbnc: number = 0;
    public baby_visits_not_complete_hbnc: number = 0;
    public eligible_couple: number = 0;
    public family_planning_not_used: number = 0;
    public total_still_birth: number = 0;
    public total_deaths: number = 0;
    public total_deaths_below_five_years: number = 0;
    public pnc_deaths: number = 0;
    public total_deaths_above_thirty_years: number = 0;
    public fully_immunized: number = 0;
    public zero_day_immunized: number = 0;
    public immunization_started_but_not_complete: number = 0;
    public total_abortion: number = 0;
    public total_miscarriage: number = 0;

    public static FromTransportData(td: TransportData): Dashboards[] {
        let result: Dashboards[] = [];

        let dcs = DataContainerService.GetInstance();

        if (dcs.CollectionExists(td.MainData, Dashboards.EmbedCollectionName)) {
            let coll = dcs.GetCollection(td.MainData, Dashboards.EmbedCollectionName)!;
            for (let data of coll.Entries) {
                result.push(data as Dashboards);
            }
        }
        else if (dcs.CollectionExists(td.MainData, "dashboard_response_view")) {
            let coll = dcs.GetCollection(td.MainData, "dashboard_response_view")!;
            for (let data of coll.Entries) {
                result.push(data as Dashboards);
            }
        }
        return result;
    }
}

// Aliases matching backend class name and convention
export { Dashboards as DashboardResponseView, Dashboards as dashboard_response_view };